/* global JSX */
//Dialog
//***********************************************************************************************************************
import * as React from "react";
import * as storeTypes from "../../models/store/storeTypes";
import { Button } from "ui/Scripts/source/components/framework/button";
import { Base } from "ui/Scripts/source/framework/base";
import { Translations } from "ui/Scripts/source/models/translations";
import { DialogButtonType } from "ui/Scripts/source/models/enums";

export interface IDialogButton {
    title: any;
    buttonType: DialogButtonType;
    classes?: string;
    disabled?: boolean;
    tooltip?: string;
    onClick: (id?: string) => void;
}

export interface IDialogProp {
    classes?: string;
    hide?: boolean;
    title: string | JSX.Element;
    body: string | JSX.Element;
    buttons: IDialogButton[];
    onClose?: () => void;
}

export class Dialog extends React.Component<IDialogProp, {}> {
    handleButtonClick = (button: IDialogButton) => {
        if (!button) return;
        if (button.disabled) return;
        button.onClick();
    };

    // ReSharper disable UnusedParameter
    handleCloseClick = (e) => {
        if (!Base.isNullOrUndefined(this.props.onClose)) {
            this.props.onClose();
        }
    };
    // ReSharper restore UnusedParameter

    render() {
        const props = this.props;
        if (props.hide) {
            return null;
        }
        //Create button
        const dialogButtons: JSX.Element[] = [];
        for (let i = 0; i < props.buttons.length; i++) {
            const button = props.buttons[i];
            if (button.onClick === null) continue;
            dialogButtons.push(<Button key={i} buttonType={button.buttonType} classes={button.classes} title={button.title} tooltip={button.tooltip} disabled={button.disabled} onClick={() => this.handleButtonClick(button)}/>);
        }
        const dialogClasses = "jj-dialog modal fade in show" + (!Base.isNullOrEmpty(props.classes) ? " " + props.classes : "");
        return (
            <div className={dialogClasses}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header draggable">
                            <h5 className="modal-title">{props.title}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.handleCloseClick}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {props.body}
                        </div>
                        {dialogButtons.length > 0 &&
                            <div className="modal-footer">
                                {dialogButtons}
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

//ConfirmationDialog
//***********************************************************************************************************************
export interface IConfirmationDialogCallback {
    (): void;
}

export interface IConfirmationDialogCall {
    (title: string, text: any, yesCallback: IConfirmationDialogCallback, noCallback: IConfirmationDialogCallback): void;
}

export interface IConfirmationDialogProp {
    classes?: string;
    type: storeTypes.ConfirmationDialogType;
    title: string;
    text: any;
    onYes: IConfirmationDialogCallback;
    onNo: IConfirmationDialogCallback;
    onCancel: IConfirmationDialogCallback;
}

export class ConfirmationDialog extends React.Component<IConfirmationDialogProp, {}> {
    handleYesClick = () => {
        this.props.onYes();
    };

    handleNoClick = () => {
        this.props.onNo();
    };

    handleCancelClick = () => {
        this.props.onCancel();
    };

    render() {
        const props = this.props;
        const dialogClasses = "confirmation" + (props.type === storeTypes.ConfirmationDialogType.Warning ? " warning" : " information") + (!Base.isNullOrEmpty(props.classes) ? " " + props.classes : "");
        const buttons: IDialogButton[] = [{ title: Translations.Yes, buttonType: DialogButtonType.Primary, onClick: this.handleYesClick }, { title: Translations.No, buttonType: DialogButtonType.Default, onClick: this.handleNoClick }];
        if (!Base.isNullOrUndefined(props.onCancel)) {
            buttons.push({ title: Translations.Cancel, buttonType: DialogButtonType.Default, onClick: this.handleCancelClick });
        }
        return (
            <Dialog
                classes={dialogClasses}
                title={props.title}
                body={props.text}
                buttons={buttons}
                onClose={this.handleNoClick}
            />
        );
    }
}
